import React, { useEffect, useRef } from 'react';

const ServiceModal = ({ service, onClose, onContactClick }) => {
  const videoRef = useRef(null);
  
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);
  
  useEffect(() => {
    // Ensure video plays when modal opens
    if (videoRef.current) {
      const playVideo = () => {
        videoRef.current.play().catch(error => {
          console.log('Modal video autoplay failed:', error);
          // Try again on user interaction
          const handleUserInteraction = () => {
            videoRef.current.play().catch(console.error);
            document.removeEventListener('click', handleUserInteraction);
            document.removeEventListener('touchstart', handleUserInteraction);
          };
          document.addEventListener('click', handleUserInteraction, { once: true });
          document.addEventListener('touchstart', handleUserInteraction, { once: true });
        });
      };
      
      // Small delay to ensure video is loaded
      setTimeout(playVideo, 100);
    }
  }, [service]);

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal active" onClick={handleBackdropClick}>
      <div className="modal-content">
        <span className="close-modal" onClick={onClose}>&times;</span>
        <div className="modal-header">
          <h2>{service.title}</h2>
        </div>
        <div className="modal-body" dangerouslySetInnerHTML={{ __html: service.description }} />
        
        {/* Video preview for services with video files */}
        {(service.id === 'music' || service.id === 'corporate' || service.id === 'promo' || service.id === 'film') && (
          <div className="modal-video-preview">
            <video 
               ref={videoRef}
               className="modal-video"
               autoPlay
               muted
               loop
               playsInline
               preload="auto"
               onLoadedData={() => {
                 if (videoRef.current) {
                   videoRef.current.play().catch(error => {
                     console.log('Video play on load failed:', error);
                   });
                 }
               }}
               onError={(e) => console.log('Video failed to load:', e)}
             >
              <source 
                src={`./${service.id === 'music' ? 'MusicVideos' : 
                         service.id === 'corporate' ? 'Corparate' : 
                         service.id === 'promo' ? 'Promo' : 
                         service.id === 'film' ? 'Film' : ''}.mp4`} 
                type="video/mp4" 
              />
              Your browser does not support the video tag.
            </video>
          </div>
        )}
        
        <div className="modal-footer">
          <button className="modal-cta" onClick={onContactClick}>Contact Us</button>
        </div>
      </div>
    </div>
  );
};

export default ServiceModal;